import { IS_PRODUCTION_CHANNEL } from '../channel';

/**
 * Silences the console on production only. The hosted dev build keeps it: it
 * is where changes are tested on other machines, and a quiet console there
 * hides exactly what the test is looking for.
 */
export function configureConsole() {
  if (IS_PRODUCTION_CHANNEL) {
    console.log = () => {};
    console.error = () => {};
  }
}
